<template>
  <div class="mb-3 mt-1">
    <div v-if="show_head" class="row mt-4">
      <div class="col-12 title text-center">
        <strong>{{$t('title_rev')}}</strong>
      </div>
      <div class="col-12 ye_border"></div>
    </div>

    <div id="jump_paginate"></div>
    <div class="border-bottom" v-for="rev in revs" :key="rev.id">
      <div class="row mt-5 mb-3 pl-3">
        <div class="col-12">
          <div class="row">
            <div class="col-3 text_sm_08 pl-0 pr-0 d-flex align-items-center">{{$t('name')}}</div>
            <div class="col-9">{{rev.name}}</div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-3 text_sm_08 pl-0 pr-0 d-flex align-items-center">{{$t('model_name')}}</div>
            <div class="col-9">{{rev.model_name}}</div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div
              class="col-5 text_sm_08 pl-0 pr-0 d-flex align-items-center"
            >{{$t('price_and_status')}}</div>
            <div
              class="col-7"
            >{{newOldEtcChange(rev.used_new,page_state.lang)}} {{currencyExchangeReview(rev.price,rev.raw_lang,page_state.lang)}}</div>
          </div>
        </div>

        <div class="col-6 text_sm_08 pt-2">{{$t('sound')}}</div>
        <div class="col-6 text_sm_08 pt-2">{{$t('satisfied')}}</div>
        <div class="col-6 text_sm_07">
          <star-rating :show-rating="false" :star-size="18" :rating="rev.sound" :read-only="true"></star-rating>
        </div>
        <div class="col-6 text_sm_07">
          <star-rating
            :show-rating="false"
            :star-size="18"
            :rating="rev.satisfied"
            :read-only="true"
          ></star-rating>
        </div>
      </div>

      <div class="row pt-1 pb-1 bg_gray">
        <div class="col-12" v-html="rev.body_raw"></div>
      </div>
      <div v-if="rev.body_translation !== ''" class="row pt-1 pb-1 bg_gray">
        <div class="col-12 border-bottom mb-2 bg_white">Translation</div>
        <div class="col-12" v-html="rev.body_translation"></div>
      </div>
    </div>

    <div v-if="here_btn">
      <div class="row mt-4">
        <div class="col-3"></div>
        <div class="col-6 text-center">
          <button
            type="button"
            class="btn btn-block bg_brown text_white pl-0 pr-0 pt-0 pb-0"
            v-on:click="jumpReview($event)"
          >{{$t('more_show')}}</button>
        </div>
        <div class="col-3"></div>
      </div>
    </div>

    <div v-if="paginate_btn" class="row mt-4">
      <div class="col-12">
        <nav>
          <ul class="pagination d-flex flex-wrap">
            <!-- <li class="page-item">
              <a
                class="page-link"
                v-bind:href="paginate.prev_page_url"
                v-on:click="clickPagenate('prev',$event)"
              >Prev</a>
            </li>-->

            <li
              v-for="n in this.paginate.last_page"
              :key="n"
              class="page-item"
              v-bind:class="{active: n == paginate.current_page}"
            >
              <span v-if="n == paginate.current_page" class="page-link">
                {{n}}
                <span class="sr-only">(current)</span>
              </span>
              <a
                v-else
                class="page-link"
                href="#jump_sale_series"
                v-on:click="clickPagenate(n,$event)"
              >{{n}}</a>
            </li>

            <!-- <li class="page-item">
              <a
                class="page-link"
                v-bind:href="paginate.next_page_url"
                v-on:click="clickPagenate('next',$event)"
              >Next</a>
            </li>-->
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import mixCurrencyExchange from "../../mixCurrencyExchange.js";
import mixBase from "../../mixBase.js";
import review from "../../mix_pages/mix_review.js";
export default {
  mixins: [review, mixBase, mixCurrencyExchange],
};
</script>
